<template>

	<div class="board_list">
		<ul class="support_list">

			<li class="" v-for="(item, index) in noticeList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="left_box">
						<em class="cate"><span class="nc">공지</span> <span>{{ item.cateName }}</span></em>
						<strong class="tit">{{ item.title }}</strong>
					</div>
					<div class="right_box">
						<div class="right_left_box">
							<div class="auth">{{ item.writerDec }}</div> <!-- 작성자가 없으면 class="auth"태그 전체를 지워주세요. -->
							<div class="date">{{ item.createDate | datetimeFilter }}</div> <!-- 시간을 제외하고 날짜까지만 가능할까요?-->
						</div>
						<div class="right_right_box" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
							<div class="state">
								<span :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' :  !(item.statusName === '완료' || item.statusName === '확인') }">{{ item.statusName }}</span>
							</div>
						</div>
					</div>
				</a>
			</li>


			<!-- 일반게시물 -->
			<li v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="left_box">
						<em class="cate"><span class="nc" v-if="item.isNotice">공지</span> <span>{{ item.cateName }}</span></em>
						<strong class="tit">{{ item.title }}</strong>
					</div>
					<div class="right_box">
						<div class="right_left_box">
							<div class="auth">{{ item.writerDec }}</div> <!-- 작성자가 없으면 class="auth"태그 전체를 지워주세요. -->
							<div class="date">{{ item.createDate | datetimeFilter }}</div> <!-- 시간을 제외하고 날짜까지만 가능할까요?-->
						</div>
						<div class="right_right_box" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
							<div class="state">
								<span :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' :  !(item.statusName === '완료' || item.statusName === '확인') }">{{ item.statusName }}</span>
							</div>
						</div>
					</div>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "listClassic",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}

	},
	watch: {
		'boardList': (newVal, oldVal) => {
			//console.log( newVal )
		}
	}
}
</script>

<style scoped>

.support_list .date {
	width: 160px;
}

</style>